import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Users")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_vm.canManage() || _vm.canCreateMyUsers() ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      to: _vm.goToAdd()
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New user ")], 1) : _vm._e(), _vm.isConsultantOrHolding(_vm.loggedUserData) ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openSendInvitationAsConsultantModal();
      }
    }
  }, [_vm._v(" Invite user(s) ")]) : _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openSubscribtionInvitationModal();
      }
    }
  }, [_vm._v(" Invite user(s) ")]) : _vm._e(), _vm.canManage() ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isExporting
    },
    on: {
      click: function click($event) {
        return _vm.exportUsers();
      }
    }
  }, [_vm._v(" Export filtered list ")]) : _vm._e()], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Search for a mail, name, origin ...",
      solo: "",
      "hide-details": "auto",
      "append-icon": "fa-search",
      loading: _vm.datatable_loading,
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      blur: function blur($event) {
        _vm.formSearch.label != _vm.searchLabelLastUsed && _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VSelect, {
    attrs: {
      items: _vm.listUserGroups,
      "item-value": "id",
      "item-text": "name",
      label: "User group",
      "hide-details": "auto",
      solo: "",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.user_group != _vm.searchGroupLastUsed && _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.user_group,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "user_group", $$v);
      },
      expression: "formSearch.user_group"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.userActiveChoice,
      label: "User activation",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.active,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "active", $$v);
      },
      expression: "formSearch.active"
    }
  }), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c(VSelect, {
    attrs: {
      label: "Salesperson",
      items: _vm.listSalesman,
      "item-value": "id_user",
      "item-text": "fullname",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.salesmanId,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "salesmanId", $$v);
      },
      expression: "formSearch.salesmanId"
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "searchLocation"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.listCountries,
      "item-value": "iso_code",
      "item-text": "printable_name",
      label: "Countries",
      "hide-details": "auto",
      solo: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.countryIsoCodes != _vm.searchCountriesLastUsed && _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.countryIsoCodes,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "countryIsoCodes", $$v);
      },
      expression: "formSearch.countryIsoCodes"
    }
  }), _vm.listStatesAvailable.length > 0 ? _c(VAutocomplete, {
    staticClass: "searchLocation-state",
    attrs: {
      items: _vm.listStatesAvailable,
      "item-value": "iso_state",
      "item-text": "state_label",
      label: "States",
      "hide-details": "auto",
      solo: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.stateIsoCodes != _vm.searchStatesLastUsed && _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.stateIsoCodes,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "stateIsoCodes", $$v);
      },
      expression: "formSearch.stateIsoCodes"
    }
  }) : _vm._e(), _c(VTextField, {
    attrs: {
      placeholder: "Delivery city",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      blur: function blur($event) {
        _vm.formSearch.city != _vm.searchCityLastUsed && _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.city = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.city,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "city", $$v);
      },
      expression: "formSearch.city"
    }
  })], 1), _c("div", {
    staticClass: "--flex-start"
  }, [_c(VCheckbox, {
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      "hide-details": "auto",
      label: "Include archived users"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.include_archive,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "include_archive", $$v);
      },
      expression: "formSearch.include_archive"
    }
  }), _c(VCheckbox, {
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      "hide-details": "auto",
      label: "Include declined users"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.includeDeclined,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "includeDeclined", $$v);
      },
      expression: "formSearch.includeDeclined"
    }
  })], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.baseModel.numberOfUsers
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.baseModel.users,
      "item-key": "id_user",
      "items-per-page": _vm.formSearch.paging.limits,
      loading: _vm.datatable_loading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_vm._v(" You do not have any customers yet, invite or create new ones. ")];
      },
      proxy: true
    }, {
      key: "item.login",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", [_vm._v(_vm._s(item.login))]), item.contactEmail ? _c("div", {
          staticClass: "text-xs"
        }, [_vm._v("Contact: " + _vm._s(item.contactEmail))]) : _vm._e(), item.billingEmail ? _c("div", {
          staticClass: "text-xs"
        }, [_vm._v("Bill: " + _vm._s(item.billingEmail))]) : _vm._e()];
      }
    }, {
      key: "item.full_name",
      fn: function fn(_ref2) {
        var _vm$getFullNameUser;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s((_vm$getFullNameUser = _vm.getFullNameUser(item, false)) !== null && _vm$getFullNameUser !== void 0 ? _vm$getFullNameUser : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.company_name",
      fn: function fn(_ref3) {
        var _item$company_name;
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s((_item$company_name = item.company_name) !== null && _item$company_name !== void 0 ? _item$company_name : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.user_group",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm.listUserGroups.find(function (x) {
          return x.id === item.user_group;
        }) ? [_vm._v(" " + _vm._s(_vm.listUserGroups.find(function (x) {
          return x.id === item.user_group;
        }).name) + " "), item.user_group === "ADMIN" ? [item.isHolding ? _c("span", [_vm._v(_vm._s(" - Corporate"))]) : !!item.consultant_code ? _c("span", [_vm._v(_vm._s(" - Consultant"))]) : item.isSalesman ? _c("span", [_vm._v(_vm._s(" - Salesperson"))]) : _vm._e()] : _vm._e()] : item.isHolding ? [_vm._v(_vm._s("Corporate"))] : [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")]];
      }
    }, {
      key: "item.delivery_address",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.computeDeliveryAddress(item)) + " ")];
      }
    }, {
      key: "item.salesman",
      fn: function fn(_ref6) {
        var _item$salesman_follow;
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(((_item$salesman_follow = item.salesman_follower) === null || _item$salesman_follow === void 0 || (_item$salesman_follow = _item$salesman_follow.fullname) === null || _item$salesman_follow === void 0 ? void 0 : _item$salesman_follow.length) > 0 ? item.salesman_follower.fullname : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.utm_source",
      fn: function fn(_ref7) {
        var _item$userSignUpLink$, _item$userSignUpLink;
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s((_item$userSignUpLink$ = (_item$userSignUpLink = item.userSignUpLink) === null || _item$userSignUpLink === void 0 ? void 0 : _item$userSignUpLink.utmSource) !== null && _item$userSignUpLink$ !== void 0 ? _item$userSignUpLink$ : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [item.isSubscriptionPendingActivation ? _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "blue"
          }
        }, [_vm._v("fa-clock")]), _vm._v(" Pending subscription "), _c("div", {
          staticClass: "flex my-2"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 highlight",
          attrs: {
            rounded: true
          },
          on: {
            click: function click($event) {
              return _vm.acceptUserSubscription(true, item);
            }
          }
        }, [_vm._v(" Approve & Notify ")]), _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: true
          },
          on: {
            click: function click($event) {
              return _vm.declineUserSubscription(false, item);
            }
          }
        }, [_vm._v(" Decline Silently ")])], 1)], 1) : _c("div", [item.active ? _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "green"
          }
        }, [_vm._v("fa-check")]), _vm._v(" Activated ")], 1) : _vm._e(), !item.active && !_vm.isUserSubscriptionDeclined(item) ? _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "red"
          }
        }, [_vm._v("fa-times")]), _vm._v(" Deactivated ")], 1) : _vm._e(), item.archive ? _c("div", {
          staticClass: "text-red"
        }, [_vm._v("Archived")]) : _vm._e(), _vm.isUserSubscriptionDeclined(item) ? _c("div", {
          staticClass: "text-red"
        }, [_c(VIcon, {
          attrs: {
            small: "",
            color: "red"
          }
        }, [_vm._v("fa-ban")]), _vm._v(" Declined ")], 1) : _vm._e()])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.goToUserPage(item)
          }
        }, [_vm._v(" " + _vm._s(_vm.canManageSpecificUser(item) ? "Edit" : "View") + " ")]), _vm.canEditRoles() ? _c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.goToUserRoles(item)
          }
        }, [_vm._v(" Edit Roles ")]) : _vm._e()], 1)];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.baseModel.numberOfUsers
    }
  })], 1)])]) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("SubscriptionInvitationModal", {
    ref: "SubscriptionInvitationModal"
  }), _c("SendInvitationAsConsultantModal", {
    ref: "SendInvitationAsConsultantModal"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };